import { styled } from 'styled-components'

export const Container = styled.div<{ $active: boolean }>`
  position: fixed;
  display: ${({ $active }) => ($active ? 'block' : 'none')};
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: var(--dark);
  z-index: 1;
`
export const Content = styled.div`
  width: 100%;
  margin: auto;
  max-width: 720px;
  padding: var(--padding-m) var(--padding-s) var(--padding-l);
  figure {
    margin: var(--padding-m) 0 var(--padding-l);
  }
  figcaption a {
    display: inline-block;
    color: var(--highlight);
    border-bottom: 1px solid var(--highlight);
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
  }
  img {
    width: 100%;
  }
  video {
    width: 100%;
  }
  > p {
    margin-bottom: var(--padding-l);
  }
`

export const Close = styled.button`
  position: fixed;
  top: 0;
  right: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  font-size: 2.8rem;
  justify-content: center;
  border-radius: 0 0 0 16px;
  border-right: none;
  border-top: none;
  border-left: 2px solid var(--dark);
  border-bottom: 2px solid var(--dark);
  background: var(--light);
  color: var(--dark);
  z-index: 2;
`
